export default {
	legacySyncBanner: {
		title: 'Wichtiges Sync-Update verfügbar',
		message:
			'Für Ihre Datensynchronisation steht ein wichtiges Update bereit. Der bisherige automatische Update-Weg ist nicht mehr verfügbar. Bitte installieren Sie das Update einmalig über den Installer.',
		download: 'Installer herunterladen',
		dismiss: 'Hinweis ausblenden',
		downloadError:
			'Die Adresse für den Installer konnte gerade nicht abgerufen werden. Bitte versuchen Sie es in Kürze erneut.',
	},
}
